import { render } from "./CheckPermissionPropsCmp.vue?vue&type=template&id=068ce043"
import script from "./CheckPermissionPropsCmp.vue?vue&type=script&lang=js"
export * from "./CheckPermissionPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__